import { call, select } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import { getCaseNumber } from '@reducers/appReducer';

export function* summaryToInboxSaga() {
    try {
        const caseNumber = yield select(getCaseNumber);
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        yield call([ssapService, ssapService.sendToInbox], { caseNumber });
    } catch(e){
        const { console, console: { log } } = global;
        yield call([console, log], 'Error happened while sending summary to Inbox');
    }
}